import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';

// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { DataStorageService } from './../../../shared/services/data-storage.service';
import { CopyService } from '../../../shared/services/app-copy.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
// globals
import { COUNTRY_CODES } from '../../../shared/globals';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

declare var ga: any;

@Component({
  selector: 'app-register-details',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './register-details.component.html',
  styleUrls: ['./register-details.component.scss'],
  providers: [
    LoginService
  ]
})
export class RegisterDetailsComponent implements OnInit, OnDestroy {

  private _userSubscription: Subscription;
  private _userLoginSubscription: Subscription;
  private _userUpdateSubscription: Subscription;
  private _dataSavedSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  public showLoader: Boolean = false;
  public user;
  public countryCode;
  public phonePattern = /^[0-9]*$/;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';
  public countryCodes = {
    featured: [...COUNTRY_CODES.featured],
    all: [...COUNTRY_CODES.featured, ...COUNTRY_CODES.all]
  }

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _errorService: ErrorHandler,
    private _dataStorageService: DataStorageService,
    private _copyService: CopyService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    this._userLanguageSubscription = this._appStore.select('copyReducer')
    .subscribe((res: any) => {
    this.selectedLanguage = res.language
    })

    this._copyService.getStaticCopy()
      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {
              this.getCopy();
            }

        })

    this.countryCode = '44';

    this._userSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        this.user = user;
      });

    this._userLoginSubscription = this._loginService.updateUserSubject$
      .subscribe(res => {
        if (res.error) {
          this.handleError();
          return;
        }

        this._loginService.loginUser(true, false, this.user.userDetails.userToken);
      });

    this._userUpdateSubscription = this._loginService.userSubject$
      .subscribe(res => {

        const messageData = {
          icon: 'tick_in_circle',
          sticky: false,
          type: 'success',
          text: 'Your details have been saved. You will be re-directed to your account page.'
        };

        this._errorService.handleCustomInfo(messageData);

        if (isPlatformBrowser(this.platformId)) {
          ga('send', 'event', 'Signup', 'Success');
        }

        this._dataStorageService.saveData();

      });

    this._dataSavedSubscription = this._dataStorageService.dataSaved$
      .subscribe(res => {
        if (res) {
          this._router.navigate(['my-account/home']);
          this.showLoader = false;
        }
      });

  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'register',
      ['registerDetailScreen']
    );
    // console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }
  handleError() {
    this.showLoader = false;
  }

  handleSubmitRegisterDetails(value, e) {
    e.preventDefault();
    this.showLoader = true;
    this._loginService.updateUserAccount(value, this.user.userDetails.userToken, this.user.userDetails.currentUser.userId);
  }

  ngOnDestroy() {
    this._dataSavedSubscription.unsubscribe();
    this._userSubscription.unsubscribe();
    this._userLoginSubscription.unsubscribe();
    this._userUpdateSubscription.unsubscribe();
  }

}
